import './AddressButton.css';

export const AddressButton = ({ label, address, onClick }) => {
  return (
    <button className="address-btn" onClick={onClick}>
      <i className="icon-location" ></i>
      <div className="address-text">
        <span className="label">{label}</span>
        <span className="address">{address}</span>
      </div>
    </button>
  );
};